import React from 'react';
const IconActionEditFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 16.09V21H7.91L19 9.90998L14.09 4.99998L3 16.09ZM16.92 2.16998L15.51 3.57998L20.42 8.48998L21.83 7.07998L16.92 2.16998Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconActionEditFill;